/**
 * Algolia search params for "open roles" on a company profile.
 * Facet filters must use `facetFilters` (not the `filters` string) to match SearchContext / index settings.
 */
const OPEN_ROLES_ATTRIBUTES_TO_RETRIEVE = [
  'objectID',
  'title',
  'normalisedTitle',
  'normalisedRoleLevel',
  'remoteness',
  'location',
  'postedDate',
  'salaryRangeMin',
  'salaryRangeMax',
  'url',
  'companyId',
] as const;

export interface BuildCompanyOpenRolesAlgoliaParamsOptions {
  companyId: string;
  hitsPerPage?: number;
  /** Align with SRP default (Finland jobs only). */
  includeIsFinlandFacet?: boolean;
}

export function buildCompanyOpenRolesAlgoliaParams(
  options: BuildCompanyOpenRolesAlgoliaParamsOptions,
): {
  query: string;
  hitsPerPage: number;
  facetFilters: string[];
  attributesToRetrieve: string[];
} {
  const trimmed = (options.companyId ?? '').trim();
  if (!trimmed) {
    throw new Error('buildCompanyOpenRolesAlgoliaParams: companyId is required');
  }
  const hitsPerPage = options.hitsPerPage ?? 10;
  const includeIsFinlandFacet = options.includeIsFinlandFacet !== false;

  const facetFilters: string[] = [`companyId:${trimmed}`];
  if (includeIsFinlandFacet) {
    facetFilters.push('isFinland:true');
  }

  return {
    query: '',
    hitsPerPage,
    facetFilters,
    attributesToRetrieve: [...OPEN_ROLES_ATTRIBUTES_TO_RETRIEVE],
  };
}
